import React, {Component} from 'react';
import {NavLink} from "react-router-dom";
import {
    Nav,
    NavItem,
    NavbarToggler,
    NavbarBrand,
} from 'reactstrap';

class Header extends Component {

    constructor(props) {
        super(props);
        this.dropdownUser = this.dropdownUser.bind(this);
    }

    sidebarToggle(e) {
        e.preventDefault();
        document.body.classList.toggle('sidebar-hidden');
    }

    sidebarMinimize(e) {
        e.preventDefault();
        document.body.classList.toggle('sidebar-minimized');
    }

    mobileSidebarToggle(e) {
        e.preventDefault();
        document.body.classList.toggle('sidebar-mobile-show');
    }

    asideToggle(e) {
        e.preventDefault();
        document.body.classList.toggle('aside-menu-hidden');
    }

    dropdownUser() {
        this.userDropdown.classList.toggle('open');
    }

    render() {

        const brand = () => {
            return (
                <h2>RetailPilot</h2>
            )
        };

        return (
            <header className="app-header navbar">
                <NavbarToggler className="d-lg-none" onClick={this.mobileSidebarToggle}>&#9776;</NavbarToggler>
                <NavbarBrand href="#" tag={brand}></NavbarBrand>
                <NavbarToggler className="d-md-down-none mr-auto" onClick={this.sidebarToggle}>&#9776;</NavbarToggler>
                <NavLink to={'/logout'} className="nav-link" activeClassName="active">Logout</NavLink>
            </header>
        )
    }
}

export default Header;



// WEBPACK FOOTER //
// ./src/admin/components/Header/Header.js